import { render, staticRenderFns } from "./PasswordConfirm.vue?vue&type=template&id=38fc82b6&"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports